import type { Summary } from '|/app/services';
import type { VehicleSummary } from './components/vehicle-card';
import { deriveCashCreditBalance } from './derive-cash-credit-balance';

export function deriveVehicleSummary(summary: Summary): VehicleSummary {
  const { vehicle, funding, payment, totals, tradeIn } = summary;
  const fundingType = funding?.type?.toLowerCase();
  const fundingInstitution = funding?.institution?.toLowerCase();
  const isCash = fundingType === 'cash';
  const isCarvanaFinancing = fundingType === 'financing' && fundingInstitution === 'carvana';
  const isThirdParty = fundingType === 'thirdparty';
  const isOutsideFinance = fundingType === 'financing' && !isCarvanaFinancing;
  const isSaf = isThirdParty || isOutsideFinance;

  const purchaseType: VehicleSummary['purchaseType'] = isCash ? 'cash' : isSaf ? 'saf' : 'finance';

  const refundDue = payment?.refundDue ?? 0;
  const hasRefundDue = refundDue > 0;
  const cashCreditBalance = deriveCashCreditBalance(payment, tradeIn);
  const useCashCreditBalance = isCash && !hasRefundDue && cashCreditBalance !== null;
  const cashDue = hasRefundDue ? -refundDue : payment?.dueAtOrder;
  const totalPurchasePrice = hasRefundDue
    ? -refundDue
    : isSaf
      ? payment?.dueAtOrder
      : useCashCreditBalance
        ? cashCreditBalance
        : totals?.totalPrice;
  return {
    vehicleId: vehicle?.id,
    stockNumber: vehicle?.stockNumber ?? null,
    year: vehicle?.year ?? 0,
    make: vehicle?.make ?? '',
    model: vehicle?.model ?? '',
    trim: vehicle?.trim ?? '',
    listingPrice: totals?.vehicleStickerPrice ?? 0,
    mileage: vehicle?.odometer ?? 0,
    purchaseType,
    monthlyPayment: funding?.loan?.payment,
    cashDue,
    totalPurchasePrice,
    showTotalDue: useCashCreditBalance
  };
}
